import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  const includes = ['Manual CIÁTICA SOS (PDF completo)', 'Técnica del Lado de Escape', 'Ergonomía de Guerrilla', 'El Descenso de Comando', 'Checklist de Emergencia + Red Flags', 'Acceso inmediato y de por vida'];
  return <section id="precio" className="bg-slate-950 text-white py-24 px-4 relative overflow-hidden" data-id="element-173">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-orange-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-175">
        <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 md:p-12 shadow-2xl mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-8" data-id="element-177">
            Esto es lo que obtienes hoy:
          </h2>

          <div className="bg-slate-800/50 rounded-2xl p-6 md:p-8 mb-8 border border-slate-700" data-id="element-178">
            <ul className="space-y-4" data-id="element-179">
              {includes.map((item, idx) => <li key={idx} className="flex items-center gap-4 text-lg md:text-xl font-medium" data-id="element-180">
                  <div className="bg-green-500/20 p-1 rounded-full flex-shrink-0" data-id="element-181">
                    <Check className="w-6 h-6 text-green-400" data-id="element-182" />
                  </div>
                  <span data-id="element-183">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center space-y-6 mb-12" data-id="element-184">
            <p className="text-xl md:text-2xl font-bold text-slate-300 italic" data-id="element-185">
              "No permitas que un nervio del grosor de un centímetro decida si
              puedes trabajar, conducir o vivir sin miedo."
            </p>
            <p className="text-lg text-slate-400" data-id="element-186">
              Tienes 40 o 50 años. Tienes décadas de vida activa por delante.
              Este protocolo no te va a devolver la juventud.{' '}
              <strong className="text-white" data-id="element-187">
                Pero sí puede devolverte tus mañanas.
              </strong>
            </p>
          </div>
        </div>

        {/* Guarantee / Risk Reversal */}
        <div className="max-w-3xl mx-auto text-center space-y-6 text-lg text-slate-300" data-id="element-188">
          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-189">
            Garantía de Riesgo Cero
          </h3>
          <p data-id="element-190">
            No hay trampa. No hay suscripción escondida. No hay upsell
            obligatorio.
          </p>
          <p data-id="element-191">
            $6.39 dólares — menos que un café con leche, menos que una consulta
            de copago, menos que una semana de analgésicos.
          </p>
          <p data-id="element-192">
            Y si pruebas el protocolo esta noche y mañana al despertar sientes
            que no te aportó absolutamente nada… estás a un email de distancia
            de recuperar tu dinero. Sin preguntas.
          </p>
          <p className="text-2xl font-extrabold text-orange-400 pt-6" data-id="element-193">
            Pero te pido algo: Dales 7 minutos antes de juzgar.
          </p>
        </div>

        {/* Final Emotional Close */}
        <div className="max-w-3xl mx-auto mt-24 text-center space-y-6 text-xl leading-relaxed" data-id="element-194">
          <p data-id="element-195">Piensa en cómo sería levantarte mañana en la mañana.</p>
          <p data-id="element-196">Moverte despacio. Con intención. Sin saltar.</p>
          <p data-id="element-197">Los 7 minutos del protocolo.</p>
          <p data-id="element-198">Poner los pies en el suelo.</p>
          <p className="font-bold text-white text-2xl" data-id="element-199">
            Y caminar al baño sin contener la respiración.
          </p>
          <p data-id="element-200">
            Tomar café de pie en la cocina sin ese miedo de que algo va a
            "explotar" en tu glúteo.
          </p>
          <p data-id="element-201">Llegar al trabajo. Sentarte. Hacer tu día.</p>
          <p data-id="element-202">
            Sin la niebla del dolor. Sin el reloj interno contando cuánto dura
            el analgésico.
          </p>
          <p className="pt-8 font-bold text-2xl text-white" data-id="element-203">
            Eso es lo que está al otro lado de los $6.39.
          </p>
          <p className="text-slate-400" data-id="element-204">
            No la cura de la ciática para siempre.
          </p>
          <p className="text-3xl font-extrabold text-orange-400" data-id="element-205">
            Sino el control de tus mañanas.
          </p>
          <p className="text-2xl font-bold text-white" data-id="element-206">Empezando mañana.</p>
        </div>

        <div id="precio-final" className="mt-16 text-center pb-8 bg-slate-900/50 p-8 md:p-10 rounded-2xl border border-orange-500/30 shadow-[0_0_30px_rgba(249,115,22,0.1)]" data-id="element-207">
          <p className="text-slate-400 uppercase tracking-widest font-bold mb-6" data-id="element-208">
            Inversión Única
          </p>

          <CTAButton fullWidth className="max-w-xl mx-auto mb-8" href="https://recuperatehoy.com/cart/52977094000824:1" data-id="element-209">
            Descarga "Ciática SOS"
          </CTAButton>

          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-210">
            <span className="text-xl text-slate-500 line-through font-bold" data-id="element-211">
              $27
            </span>
            <span className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-212">
              $6.39
            </span>
            <span className="bg-green-500/20 text-green-400 text-sm font-bold px-3 py-1 rounded-full" data-id="element-213">
              76% OFF
            </span>
          </div>
          <p className="text-slate-400 text-sm" data-id="element-214">
            Acceso inmediato • Pago único y seguro
          </p>
        </div>
      </div>
    </section>;
}